import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';
import { statusLabels } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  const statusClass = comic.status === 'serializing'
    ? 'bg-accent-100 text-accent-700'
    : 'bg-secondary-100 text-secondary-700';

  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block cursor-pointer"
      data-product-shop=""
    >
      <div className="relative overflow-hidden rounded-lg aspect-[5/7] bg-background-100">
        <img
          src={comic.coverImage}
          alt={comic.title}
          title={`${comic.title} - UU漫画`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <span className="text-background-50 text-xs font-medium bg-primary-500/90 px-2 py-1 rounded-full whitespace-nowrap">
            点击查看详情
          </span>
        </div>
        <span className={`absolute top-2 right-2 text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${statusClass}`}>
          {statusLabels[comic.status]}
        </span>
      </div>
      <div className="mt-2.5">
        <h3 className="text-sm font-semibold text-foreground-900 leading-tight line-clamp-1 group-hover:text-primary-500 transition-colors">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{comic.author}</p>
        <p className="text-xs text-accent-600 mt-1 font-medium line-clamp-1 whitespace-nowrap">
          最新：{comic.latestChapter}
        </p>
      </div>
    </Link>
  );
}